module.exports = __webpack_public_path__ + "r-v3/img/ml_17_00_over.256cb14c.jpg";